<template>
  <div class="Tabs">
    <div class="SDG_app">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in appMarketList" :key="index">
          <a
            :href="`${item.id}`"
            style="color:#fff"
            :class="[language == 'zh' ? 'zhFamilytitle' : 'enfamilytitle']"
          >
            <div
              class="sdg_box"
              @mouseenter="on_bot_enter"
              @mouseleave="on_bot_leave"
              :style="{'background':`${item.color}`,height:'60px'}"
            >
              <p style="color:#fff">{{ item.name }}</p>
            </div>
          </a>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev">
        <i class="iconfont icon-jiantou2"></i>
      </div>
      <div class="swiper-button-next">
        <i class="iconfont icon-jiantou"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide, Pagination } from "vue-awesome-swiper";
import {
  swiperAnimateCache,
  swiperAnimate
} from "@/assets/js/swiper.animate1.0.3.min.js";
import "swiper/dist/css/swiper.css";
export default {
  data() {
    return {
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          //自动轮播
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          init: function() {
            swiperAnimateCache(this);
            swiperAnimate(this);
          },
          slideChangeTransitionStart: function() {},
          slideChangeTransitionEnd: function() {},
          slideChange: function() {
            swiperAnimate(this);
          }
        }
      },

      LayerTextWidth: 200,
      left: 0,
      currentTable: 1
    };
  },
  components: {
    swiper,
    swiperSlide,
    Pagination
  },
  computed: {
    appMarketList() {
      return [
        {
          id: "#terraViewSDGs",
          name: "TerraView-SDGs",
          color: "rgba(34,188,255,1)"
        },
        {
          id: "#terraViewSateye",
          name: "TerraView-SatEYE",
          color: "rgba(74,159,65,1)"
        },
        {
          id: "#terraViewFire",
          name: "TerraView-Fire",
          color: "rgba(248,158,46,1)"
        },
        {
          id: "#terraViewCovidTracker",
          name: "TerraView-COVIDTracker",
          color: "rgba(221,119,103,1)"
        },
//  {
//           id: "#app9",
//           name: this.$t("App.app9"),
//           color: "rgba(34, 188, 255,1)"
//         },
        //  {
        //   id: "#app3",
        //   name: this.$t("App.app6"),
        //   color: "rgba(74,159,65,1)"
        // },
        
        // {
        //   id: "#app1",
        //   name: this.$t("App.app7"),
        //   color: "rgba(34, 188, 288,1)"
        // }
        // ,{
        //   id: "#app4",
        //   name: this.$t("App.app5"),
        //   color: "rgba(246, 203, 75,1)"
        // }
       
      ];
    },
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    on_bot_enter() {
      //鼠标放上暂停轮播
      this.swiper.autoplay.stop();
    },
    on_bot_leave() {
      this.swiper.autoplay.start();
    },
    getWidth(val) {
      this.currentTable = val;

      this.left = val * this.LayerTextWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1026px) {
.Tabs {
  width: 100%;
  padding-top: 10px;
  // height: 60px;
  background: #f1f1f1;
  border-bottom: 2px solid #f2f3f3;
  .SDG_app {
    width: 100%;
    padding: 0 34px;
    margin: 6px auto;
    position: relative;
    overflow: hidden;
    // height: 100px;

    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev:hover i {
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
      background: #eeeded;
    }
    .swiper-button-next:hover i {
      background: #eeeded;
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
    }
    .swiper-button-prev {
      left: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      padding: 10px 5px;

      &:hover .banner_img {
        transition: 0.2s;
        transform: scale(1.2);
      }
      &:hover {
        transition: 0.2s;
        background: rgba(159, 226, 245, 0.1);
      }
      &:hover p {
        transition: 0.2s;
        font-weight: 600;
        color: rgb(40, 89, 250);
      }

      cursor: pointer;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner_img {
        transition: 0.2s;
        object-fit: cover;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
      p {
        margin-top: 8px;
        transition: 0.2s;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
}
}
@media screen and (min-width: 768px) and (max-width: 1025px) {
 .Tabs {
  width: 100%;
  padding-top: 10px;
  // height: 60px;
  background: #f1f1f1;
  border-bottom: 2px solid #f2f3f3;
  .SDG {
    width: 100%;
    padding: 0 34px;
    margin: 6px auto;
    position: relative;
    overflow: hidden;
    // height: 100px;

    .swiper-button-prev,
    .swiper-button-next {
      position: absolute;
      background: none;
      display: flex;
      align-items: center;
    }
    .swiper-button-prev:hover i {
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
      background: #eeeded;
    }
    .swiper-button-next:hover i {
      background: #eeeded;
      font-size: 16px;

      color: rgba(18, 139, 237, 1);
    }
    .swiper-button-prev {
      left: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }
    .swiper-button-next {
      right: 0px;
      i {
        border-radius: 8px;
        padding: 4px;
        color: rgba(18, 139, 237, 0.5);
        font-size: 14px;
      }
    }

    .swiper-container {
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
    .sdg_box {
      padding: 10px 5px;

      &:hover .banner_img {
        transition: 0.2s;
        transform: scale(1.2);
      }
      &:hover {
        transition: 0.2s;
        background: rgba(159, 226, 245, 0.1);
      }
      &:hover p {
        transition: 0.2s;
        font-weight: 600;
        color: rgb(40, 89, 250);
      }

      cursor: pointer;
      width: 100%;
      height: 100%;
      background: #fff;
      border-radius: 3px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .banner_img {
        transition: 0.2s;
        object-fit: cover;
        width: 50px;
        height: 50px;
        border-radius: 4px;
      }
      p {
        margin-top: 8px;
        transition: 0.2s;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
} 
}
</style>